import { useGate, useStore, useStoreMap } from 'effector-react'
import { debtModel } from '~/entities/Debt'
import { mainBalance } from '~/entities/MainBalance'
import { CURRENCY } from '~/shared/config/constants'
import { parseSumForUi } from '~/shared/lib/utils'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { Wrapper, NavText, TitleWrapper, Img, Title } from './styled'

export function BalanceNav() {
  useGate(debtModel.Gate)

  const isBalanceReportLoading = useStore(
    mainBalance.getCurrentBalanceReportFx.pending,
  )
  const report = useStore(debtModel.$report)

  const profitAmount = useStoreMap(
    mainBalance.$currentBalanceReport,
    (balanceReport) => balanceReport?.getProfitAmount() || 0,
  )

  return (
    <>
      <Wrapper to='/balance-histories' data-testid='button-balance-histories'>
        <TitleWrapper>
          <Img src='/images/icon-wallet.svg' alt='' />
          <Title>Заработок сегодня</Title>
        </TitleWrapper>

        <NavText data-testid='balance-histories-profit-amount'>
          {isBalanceReportLoading ? (
            <Skeleton animated $height={27} style={{ margin: 0 }} />
          ) : (
            <>
              <strong>{parseSumForUi(profitAmount)} </strong>
              {CURRENCY}
            </>
          )}
        </NavText>
      </Wrapper>
      {Boolean(report?.debt) && (
        <Wrapper to='/debts'>
          <TitleWrapper>
            <Img src='/images/icon-debts-circle.svg' alt='' />
            <Title>Задолженности</Title>
          </TitleWrapper>
          <NavText>
            <strong>{parseSumForUi(report?.debt)}</strong>
            {CURRENCY}
          </NavText>
        </Wrapper>
      )}
    </>
  )
}
